var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5007 19.6668C32.2171 19.6668 34.4173 17.4666 34.4173 14.7502C34.4173 12.0337 32.2171 9.8335 29.5007 9.8335C26.7842 9.8335 24.584 12.0337 24.584 14.7502C24.584 17.4666 26.7842 19.6668 29.5007 19.6668ZM29.5007 24.5835C26.7842 24.5835 24.584 26.7837 24.584 29.5002C24.584 32.2166 26.7842 34.4168 29.5007 34.4168C32.2171 34.4168 34.4173 32.2166 34.4173 29.5002C34.4173 26.7837 32.2171 24.5835 29.5007 24.5835ZM29.5007 39.3335C26.7842 39.3335 24.584 41.5337 24.584 44.2502C24.584 46.9666 26.7842 49.1668 29.5007 49.1668C32.2171 49.1668 34.4173 46.9666 34.4173 44.2502C34.4173 41.5337 32.2171 39.3335 29.5007 39.3335Z",
    fill: "#8A96A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropVertical);
export default __webpack_public_path__ + "static/media/drop_vertical.c0c015954946a7785c669ffd64e96f25.svg";
export { ForwardRef as ReactComponent };